<app-left-side-nav></app-left-side-nav>
<app-header></app-header>

<!-- page content area start -->
<div class="afterLoginPageContainer" translate="no">
    <div class="container p-0">
        <div class="mainContent">
            <div class="card" *ngIf="productDetails">
                <div class="back-btn" (click)="onClickBack()">
                    <i class="fa-solid fa-chevron-left"></i>
                </div>
                <ng-container *ngIf="productMedia && productMedia.length > 0">
                    <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel" #carousel>
                        <div class="carousel-indicators" *ngIf="productMedia.length > 1">
                            <button *ngFor="let media of productMedia; let i = index" type="button"
                                data-bs-target="#carouselExampleIndicators" [attr.data-bs-slide-to]="i"
                                [class.active]="i === 0" [attr.aria-current]="i === 0 ? 'true' : null"
                                [attr.aria-label]="'Slide ' + (i + 1)">
                            </button>
                        </div>
                        <div class="carousel-inner" [class.multiple-items]="productMedia.length > 1">
                            <div *ngFor="let media of productMedia; let i = index" class="carousel-item"
                                [class.active]="i === 0">
                                <img [src]="media.bigthumb_url"  onerror="this.src='/assets/images/default_company_image.png'"
                                (click)="openMedia(media.media_url)" (keydown.enter)="openMedia(media.media_url)" tabindex="0" class="d-block w-100" alt="Product Image">
                                <span *ngIf="media.media_type === 'youtubevideo'" class="playicon" (click)="openMedia(media.media_url)" (keydown.enter)="openMedia(media.media_url)" tabindex="0" role="button" 
                                [attr.aria-label]="'View full size product video'">
                                    <i class="fa-brands fa-youtube"></i>
                                </span>
                            </div>
                        </div>
                        <button *ngIf="productMedia.length > 1" class="carousel-control-prev" type="button"
                            data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                        </button>
                        <button *ngIf="productMedia.length > 1" class="carousel-control-next" type="button"
                            data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                        </button>
                    </div>
                </ng-container>

                <!-- Card Content -->
                <div class="card-body">
                    <div class="product-details">
                        <h2 class="product-title" [style.color]="productDetails.image_max_color || '#009F4B'">
                            {{productDetails.title_english}}</h2>
                        <p class="product-price" *ngIf="formattedPrice">
                            <span class="currency-symbol">
                                {{ productDetails.currency === 'INR' ? '₹' : '$' }}
                            </span>{{ formattedPrice }}
                            <span class="custom-color">onwards</span>
                        </p>
                        <div class="product-description">
                            <div class="inner-content">
                                <span [innerHTML]="isExpanded ? fullContent : truncatedContent"></span>
                                <ng-container *ngIf="isLongText">
                                    <a href="#" (click)="toggleReadMore($event)"
                                        [style.color]="productDetails.image_max_color || '#009F4B'">
                                        {{ isExpanded ? ' Read less' : ' Read more' }}
                                    </a>
                                </ng-container>
                            </div>
                        </div>
                        <div class="brochure-list" *ngIf="brochureList && brochureList.length > 0">
                            <h6 class="heading" [style.color]="productDetails.image_max_color || '#009F4B'">For More Details, Download Brochure</h6>
                            <ng-container *ngFor="let brochure of brochureList">
                                <a [href]="brochure.media_url" class="view-all-link" target="_blank"
                                    [download]="brochure.title">
                                    <div class="brochure">
                                        <div class="imgOuter">
                                            <img [src]="brochure.bigthumb_url" alt="">
                                        </div>
                                        <h5 class="title">{{brochure.title}}</h5>
                                        <div class="pdf-icon">
                                            <img src="assets/images/pdf-icon.png" alt="pdf icon" width="20px">
                                            <img src="assets/images/download-icon.png" alt="download icon" width="20px">
                                        </div>
                                    </div>
                                </a>
                            </ng-container>
                        </div>
                        <div class="company-info mb-5" *ngIf="productDetails">
                            <div class="company-logo">
                                <img class="img" [src]="productDetails.image_bigthumb_url" alt="Company Logo" onerror="this.src='/assets/images/default-profile-organization.jpg'">
                            </div>
                            <h5 class="company-name" (click)="viewCompanyDetails(productDetails.user_id)">
                                {{productDetails.brandname}}</h5>
                            <div class="arrow" (click)="viewCompanyDetails(productDetails.user_id)">
                                <i class="fa fa-chevron-right"></i>
                            </div>
                        </div>
                        <div class="product-recommendations">
                            <div class="inner-elements" *ngIf="!isLoadingMore && productList && productList.length > 0">

                                <h5 class="heading" [style.color]="productDetails.image_max_color || '#009F4B'">More
                                    From, {{productDetails.brandname}}</h5>
                                <div class="media-slider">
                                    <div class="product-list inner-media">
                                        <div class="block" *ngFor="let product of productList">
                                            <a (click)="viewProductDetails(product.encoded_product_id)">
                                                <div class="card">
                                                    <div class="wrapper position-relative">
                                                        <img class="card-img-top"
                                                            [src]="product.media_type === 'image' ? product.media_url : product.image_bigthumb_url"
                                                            onerror="this.src='/assets/images/default_company_image.png'" alt="{{ product.title_english }}">
                                                        <span *ngIf="product.media_type === 'youtubevideo'"
                                                            class="playicon">
                                                            <i class="fa-brands fa-youtube"></i>
                                                        </span>
                                                    </div>
                                                    <div class="card-body">
                                                        <h6 class="product-name">{{product.title_english}}</h6>
                                                        <p class="company-name">{{product.brandname}}</p>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="section-loader text-center" *ngIf="isLoadingMore">
                                <div class="spinner-border text-success" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                        <div class="catlogWrapper mt-5" (click)="goToTicketPage()" *ngIf="this.eventDetails?.allow_to_register === 1">
                            <img src="/assets/images/buy_your_ticket.png" alt="Go To Digital Catalogue" />
                        </div>
                    </div>
                </div>
                <div class="action-btns">
                    <div class="msg-div" *ngIf="successMsg"
                    [ngStyle]="{ background: successGradientBackground }">
                        <span [style.color]="productDetails.image_max_color || '#009F4B'"><i class="fa-solid fa-circle-check me-3"></i>{{ successText }}</span>
                        <a class="view-link" routerLink="/catalogue/product-wishlist" [style.color]="productDetails.image_max_color || '#009F4B'">View Shortlist</a>
                    </div>
                    <div class="wrapper">
                        <span class="outer-box" (click)="shortlistProduct()">
                            <i class="fa-regular fa-circle-check" *ngIf="!liked"></i>
                            <i class="fa-solid fa-circle-check" *ngIf="liked" [style.color]="productDetails.image_max_color || '#009F4B'" [class.like-animate]="liked"></i>
                        </span>
                        <button [style.backgroundColor]="productDetails.image_max_color || '#009F4B'"
                            class="contact-btn" (click)="openModel()"><i class="fa-solid fa-phone"></i>Contact
                            Me</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
</div>
<app-interest-share-popup 
#interestSharedPopup 
(confirmClicked)="onConfirmPopup()" 
(doNotShowAgainChange)="onDoNotShowChange($event)" 
(cancelClicked)="onCancelPopup()"></app-interest-share-popup>
<app-interest-shared-success-popup #successModal></app-interest-shared-success-popup>